<template>
<!--Footer-->
<div id="footer">
  <div id="content_footer">
    <!--copyright-->
    <div id="copyright">&copy; 2009-{{year}} StumptheSpread.com</div>
    <!--copyright ends-->
    <!--Back to top button-->
    <div id="back_to_top" v-if="!isLogin">
      <a href="#">
        <div class="sprite back_to_top" style="display:inline-block" title="Back to the Top"></div>
      </a>
    </div>
    <!--Back to top button Ends-->
  </div>
</div>
<!--Footer Ends-->
</template>

<script>
export default {
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {
    isLogin () {
      return this.$route.name === 'login'
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// StsFooter.vue?d4004f64